module.exports = __webpack_public_path__ + "static/media/CAF.3dfcecbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CAF.svg
// module id = 217
// module chunks = 0